exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* overridden by src/lib/themes/guiHelpers.js */\n\n.save-status_save-now_2shdk {\n    cursor: pointer;\n    height: 2rem;\n    display: flex;\n    align-items: center;\n    font-weight: 500;\n    font-size: 0.75rem;\n    white-space: nowrap;\n}\n", ""]);

// exports
exports.locals = {
	"save-now": "save-status_save-now_2shdk",
	"saveNow": "save-status_save-now_2shdk"
};